import { galleryButtonAutomationTypeSuffix } from "..";

export const useAutomationTypeWithGalleryButtonSuffix = (
  automationType?: string
) => {
  return (
    automationType && `${automationType}${galleryButtonAutomationTypeSuffix}`
  );
};
